import React, {
  useState, useEffect,
} from 'react';
import {
  Card, CardContent, Dialog,
} from '@material-ui/core';
import {
  stores,
} from 'mobx-store';
import {
  AddressDetails,
  AddressDetailsProps,
  AddressTypeLabels,
  initialAddress,
} from './types';
import {
  CardsDeliveryRequestDTO,
} from './DTOs/cardsDeliveryRequestDTO';

const AddressDetailsModal: React.FC<AddressDetailsProps> = (props: AddressDetailsProps) => {
  const {
    handleClose,
    modalOpen,
    requestId,
  } = props;

  const [addressToPreview, setAddressToPreview] = useState<AddressDetails>(initialAddress);

  useEffect(() => {
    if (requestId) {
      const cdRequest = stores.cardsDeliveryStore.cardsDeliveryRequestsList.find(
        (req) => req.requestId === requestId,
      );
      const {
        address,
        addressNotes,
        addressType,
        phone,
        coordinateLat,
        coordinateLong,
        userFirstName,
        day,
        timeRange,
      } = cdRequest as CardsDeliveryRequestDTO;
      setAddressToPreview({
        address,
        addressNotes,
        addressType,
        name: userFirstName,
        phone,
        coordinateLat,
        coordinateLong,
        day,
        timeRange,
      });
    }
  }, []);

  const getAddressType = (type: number) => {
    if (!AddressTypeLabels[type]) {
      return 'not set';
    }
    return AddressTypeLabels[type];
  };

  return (
    <Dialog
      open={modalOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth
    >
      <Card>
        <CardContent>
          <h2>{`Address details for Request ID ${requestId}`}</h2>
          <div>
            <h3>Name</h3>
            <p>{addressToPreview.name}</p>
            <h3>Phone</h3>
            <p>{addressToPreview.phone}</p>
          </div>
          <div>
            <h3>Address</h3>
            <p>{getAddressType(addressToPreview.addressType)}</p>
            <p>{addressToPreview.address}</p>
            {addressToPreview.address !== addressToPreview.addressNotes ? (
              <p>
                <h5>Notes: </h5>
                {addressToPreview.addressNotes}
              </p>
            ) : null}
          </div>
          {addressToPreview.day ? (
            <div>
              <h3>Preferred Delivery Time</h3>
              <p>
                <h5>Day: </h5>
                {addressToPreview.day}
                <br />
                <h5>Time range: </h5>
                {addressToPreview.timeRange}
              </p>
            </div>
          ) : null}
          {(addressToPreview.coordinateLat && addressToPreview.coordinateLong) ? (
            <div>
              <h3>Location Coordinates:</h3>
              <p>
                {`Lat: ${addressToPreview.coordinateLat}`}
                <br />
                {`Long: ${addressToPreview.coordinateLong}`}
              </p>
              {/* TODO add <iframe /> */}
            </div>
          ) : null}
        </CardContent>
      </Card>
    </Dialog>
  );
};

export default AddressDetailsModal;
